import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const faqItems = [
  {
    question: 'Voor welke WFT examens kan ik WFT Study Buddy gebruiken?',
    answer: 'Momenteel ondersteunen we WFT Schade Particulier, WFT Basis, WFT Schade Zakelijk, WFT Hypotheken, WFT Pensioen, WFT Vermogen, WFT Inkomen, WFT Consumptief Krediet, en WFT Zorg. De PE examens komen binnenkort. We breiden continu uit met nieuwe examens!'
  },
  {
    question: 'Hoe werkt de AI vraag generator precies?',
    answer: 'Onze AI analyseert de officiële WFT syllabus en genereert unieke vragen die qua niveau en stijl overeenkomen met het echte examen. Je kunt kiezen uit verschillende onderwerpen en moeilijkheidsgraden voor gerichte oefening.'
  },
  {
    question: 'Kan ik de gratis versie blijven gebruiken?',
    answer: 'Ja! De gratis versie blijft altijd beschikbaar met 5 AI vragen per dag, een proefexamen preview (10 vragen), en basis voortgang tracking. Upgrade naar Pro of koop à la carte wanneer je meer nodig hebt.'
  },
  {
    question: 'Wat krijg ik met Pro (€19,99/maand)?',
    answer: 'Met Pro krijg je: onbeperkt proefexamens, alle 9 samenvattingen, 100 AI vragen per maand, uitgebreide analytics en fout tracking met herkansingstips. Jaarlijks betalen? Dan bespaar je 33%!'
  },
  {
    question: 'Zijn de vragen vergelijkbaar met het echte examen?',
    answer: 'Ja! Onze AI is getraind op officiële WFT syllabus materialen en genereert vragen die qua moeilijkheidsgraad, onderwerpen en stijl zeer vergelijkbaar zijn met het echte examen. Veel gebruikers geven aan dat de vragen hen goed hebben voorbereid.'
  },
  {
    question: 'Kan ik ook losse producten kopen?',
    answer: 'Ja! Met à la carte koop je alleen wat je nodig hebt: samenvattingen (€4,99/stuk), proefexamens (€4,99), of AI vragen packs (vanaf €2,99). Geen abonnement nodig en credits verlopen niet.'
  },
  {
    question: 'Kan ik WFT Study Buddy op mijn telefoon gebruiken?',
    answer: 'Absoluut! WFT Study Buddy werkt op alle apparaten - desktop, tablet en smartphone. Je voortgang wordt automatisch gesynchroniseerd via de cloud.'
  },
  {
    question: 'Welke betaalmethoden accepteren jullie?',
    answer: 'We accepteren iDEAL (meest populair in Nederland), creditcards (Visa, Mastercard, American Express), en andere Europese betaalmethoden via Stripe. Alle betalingen zijn 100% veilig en encrypted.'
  }
];

const FAQ: React.FC = () => {
  // Inject FAQ JSON-LD structured data for Google rich snippets
  useEffect(() => {
    // Remove any pre-rendered version first to avoid duplicates
    const existing = document.getElementById('ld-landing-faq');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = 'ld-landing-faq';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    });
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, []);

  const emojis = ['📚', '🤖', '💳', '💰', '🎯', '🛒', '📱', '💳'];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
            ❓ Veelgestelde Vragen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Heb je nog vragen?
          </h2>
          <p className="text-xl text-gray-600">
            We hebben de meest gestelde vragen voor je beantwoord
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqItems.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {emojis[index]} {faq.question}
              </h3>
              <p className="text-gray-700">{faq.answer}</p>
            </div>
          ))}
        </div>

        {/* CTA Below FAQ */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Nog meer vragen?</p>
      <Link 
  to="/contact" 
  className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
>
  Neem contact op →
</Link>
        </div>
      </div>
    </section>
  );
};

export default FAQ;